/**
 * News Category Badge Component
 *
 * Displays category badge with icon and color
 */

import { Badge } from '@mantine/core';
import {
  IconSparkles,
  IconRefresh,
  IconBell,
  IconTool,
} from '@tabler/icons-react';
import type { NewsCategory } from '../../../../data/news/newsTypes';

interface NewsCategoryBadgeProps {
  category: NewsCategory;
  size?: 'sm' | 'md' | 'lg';
}

const CATEGORY_CONFIG = {
  feature: {
    label: 'Nowość',
    color: 'ecoGreen',
    Icon: IconSparkles,
  },
  update: {
    label: 'Aktualizacja',
    color: 'blue',
    Icon: IconRefresh,
  },
  announcement: {
    label: 'Ogłoszenie',
    color: 'yellow',
    Icon: IconBell,
  },
  maintenance: {
    label: 'Konserwacja',
    color: 'red',
    Icon: IconTool,
  },
} as const;

/**
 * News Category Badge Component
 *
 * Displays a colored badge with icon for news category
 */
export function NewsCategoryBadge({ category, size = 'md' }: NewsCategoryBadgeProps) {
  const config = CATEGORY_CONFIG[category];
  const { Icon } = config;

  return (
    <Badge
      color={config.color}
      variant="light"
      size={size}
      leftSection={<Icon size={14} />}
    >
      {config.label}
    </Badge>
  );
}
